import CreateCaseModal from "./CreateCaseModal";

export default CreateCaseModal;
